<template>
  <div class="main-layout">
    <div class="left-panel">
      <MainLeftPanel />
    </div>
    <el-scrollbar class="scroll-bar main-panel">
      <router-view />
    </el-scrollbar>
  </div>
</template>

<script>

export default {
  name: 'MainLayout',
  components: {
    MainLeftPanel: () => import('./components/MainLeftPanel.vue')
  },
  data() {
    return {}
  },
  methods: {}
}
</script>
<style scoped>
.main-layout {
  flex: 1 1 0;
  display: flex;
  flex-direction: row;
  overflow: hidden;
}

.left-panel {
  display: flex;
  flex-direction: column;
  background-color: #252f40;
}

.main-nav-menu {
  flex: 1 1 0;
}

.main-panel {
  position: relative;
  background: #3C4556;
}

.scroll-bar {
  flex: 1 1 0;

}

.scroll-bar ::v-deep .el-scrollbar__wrap {
  display: flex;
  flex-direction: column;
  overflow-x: auto;
}
</style>
